import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
  effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'fitness-force-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, HeaderComponent, TranslateModule],
})
export class PageNotFoundComponent {
  private readonly route = inject(ActivatedRoute);

  // Convert route params to signal at class level
  private routeParams = toSignal(this.route.params, {
    initialValue: {} as Record<string, string>,
  });

  errCode = signal<string>('');

  constructor() {
    // Handle route params changes
    effect(() => {
      const params = this.routeParams();
      if (params?.['errcode']) {
        this.errCode.set(params['errcode']);
      }
    });
  }
}
